import actionCreator from '../../createAction';

const createAction = actionCreator('settings');

export const GET_USERS = createAction('GET_USERS');
export const CREATE_USER = createAction('CREATE_USER');
export const DELETE_USER = createAction('DELETE_USER');
export const UPDATE_USER = createAction('UPDATE_USER');

export const UPDATE_ACCOUNT = createAction('UPDATE_ACCOUNT');
export const LOAD_ACCOUNT = createAction('LOAD_ACCOUNT');
export const LOAD_ACCOUNT_USAGE = createAction('LOAD_ACCOUNT_USAGE');
export const LOAD_UPCOMING_INVOICE = createAction('LOAD_UPCOMING_INVOICE');
export const LOAD_INTEGRATIONS = createAction('LOAD_INTEGRATIONS');
export const SAVE_INTEGRATION = createAction('SAVE_INTEGRATION');
export const GET_CONNECTIONS = createAction('GET_CONNECTIONS');
export const UPDATE_CONNECTION = createAction('UPDATE_CONNECTION');

export const TOGGLE_BANNER = createAction('TOGGLE_BANNER');
export const START_SYNC = createAction('START_SYNC');

export const LOAD_FEATURES = createAction('LOAD_FEATURES');

export const LOAD_BRANDS = createAction('LOAD_BRANDS');
